import React, { forwardRef } from 'react'
import Barcode from 'react-barcode'
import _ from 'lodash'
import './printPreview.scss'
import { getBuyerCode } from '../../../pages/savedLabels/savedShelfEdgeLabelsUtils'

const PrintPreview = forwardRef(({ products, printList, selectedPrinter }, ref) => {

  const processData = () => {
    return printList
      .filter(row => {
        const apnNumber = parseInt(row.apn, 10)
        return products.some(p => p.APN === apnNumber)
      })
      .flatMap(row => {
        const apnNumber = parseInt(row.apn, 10)
        const product = products.find(p => p.APN === apnNumber)

        if (product) {
          // Skip items with missing data
          if (product.ItemCode === null || product.ItemCode === undefined ||
            product.ItemCode.toString().length !== 8 ||
            !product.ItemPrices || !product.ItemPrices.ItemPrice ||
            product.ItemPrices.ItemPrice.RecRetailIncPrice == null ||
            !product.ItemDescription || product.ItemDescription === null ||
            product.ItemDescription === undefined) {
            return []
          }

          // Check if we have valid DepartmentCode or ReorderBuyerCode 
          const buyerCode = getBuyerCode(product)
          if (!buyerCode || buyerCode.toString().trim() === '') {
            return []
          }

          // Generate multiple entries based on quantity
          return Array(row.quantity).fill().map((_, index) => ({
            product,
            row,
            index,
            buyerCode
          }))
        }
        return []
      })
  }

  const chunkedData = _.chunk(processData(), 21)
  const processedData = processData()

  return (
    <div ref={ref} className={`print-preview ${selectedPrinter.toLowerCase()}-print-format`}>
      {selectedPrinter === 'A4' ? (
        // A4 Printer Layout
        chunkedData.map((chunk, chunkIndex) => (
          <div
            key={`chunk-${chunkIndex}`}
            className="print-preview__A4container"
          >
            {chunk.map(({ product, row, index, buyerCode }) => (
              <div
                key={`${row.apn}-${index}`}
                className="print-preview__A4-item"
              >
                <div className="product-header">
                  <div className="product-description">
                    {product.ItemDescription.toUpperCase()}
                  </div>
                  <div className="product-codes">
                    <div className="buyer-code">{buyerCode}</div>
                    <div className="item-code">{product.ItemCode}</div>
                  </div>
                </div>

                <div className="product-details">
                  <div className="price-container">
                    <div className="currency-symbol">₱</div>
                    <div className="price-value">
                      {product.ItemPrices.ItemPrice.RecRetailIncPrice}
                    </div>
                  </div>
                  <div className="barcode-container">
                    <Barcode
                      value={row.apn.toString().padStart(13, '0')}
                      format="EAN13"
                      width={1}
                      height={30}
                      margin={0}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))
      ) : (
        processedData.map(({ product, row, index, buyerCode }) => (
          <div
            key={`${row.apn}-${index}`}
            className="print-preview__Zebra-container zebra-label"
          >
            <div className="print-preview__Zebra-item">
              <div className="product-header">
                <div className="product-description">
                  {product.ItemDescription.toUpperCase()}
                </div>
                <div className="product-codes">
                  <div className="buyer-code">{buyerCode}</div>
                  <div className="item-code">{product.ItemCode}</div>
                </div>
              </div>

              <div className="product-details">
                <div className="price-container">
                  <div className="currency-symbol">₱</div>
                  <div className="price-value">
                    {product.ItemPrices.ItemPrice.RecRetailIncPrice}
                  </div>
                </div>
                <div className="barcode-container">
                  <Barcode
                    value={row.apn.toString().padStart(13, '0')}
                    format="EAN13"
                    width={1}
                    height={25}
                    margin={0}
                  />
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  )
})

export default PrintPreview